'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelQHelpers = exports.logQPromiseIssuesAndSendNonApiAlerts = exports.logQPromiseIssuesAndSendAlerts = exports.logQPromiseIssuesToConsole = undefined;

var _handleDoneErrors = require('./handleDoneErrors');

var _handleUnhandledErrors = require('./handleUnhandledErrors');

var _longStackTracesForDev = require('./longStackTracesForDev');

var _improveUnhandledRejectionString = require('./improveUnhandledRejectionString');

(0, _longStackTracesForDev.enableLongStackTracesForDev)();
(0, _improveUnhandledRejectionString.improveUnhandledRejectionString)();

var willCallBoth = function willCallBoth(func1, func2) {
  return function () {
    func1();
    func2();
  };
};

var logQPromiseIssuesToConsole = exports.logQPromiseIssuesToConsole = willCallBoth(_handleDoneErrors.logDoneRejectionsToConsole, _handleUnhandledErrors.logUnhandledErrorsToConsole);

var logQPromiseIssuesAndSendAlerts = exports.logQPromiseIssuesAndSendAlerts = willCallBoth(_handleDoneErrors.logDoneRejectionsAndSendAlerts, _handleUnhandledErrors.logUnhandledErrorsAndSendAlerts);

var logQPromiseIssuesAndSendNonApiAlerts = exports.logQPromiseIssuesAndSendNonApiAlerts = willCallBoth(_handleDoneErrors.logDoneRejectionsAndSendNonApiAlerts, _handleUnhandledErrors.logUnhandledErrorsAndSendNonApiAlerts);

var cancelQHelpers = exports.cancelQHelpers = function cancelQHelpers() {
  (0, _handleDoneErrors.cancelDoneRejectionHandler)();
  (0, _handleUnhandledErrors.cancelUnhandledPolling)();
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/q/static-5.30/js/handlers.js
// module id = 1220
// module chunks = 3